"use client";

interface FrequencyResponseImageProps {
  data: unknown;
}

type ImageData = {
  url?: string;
  src?: string;
};

export default function FrequencyResponseImage({ data }: FrequencyResponseImageProps) {
  // Handle different possible JSON structures
  const getImageUrl = (): string | null => {
    if (typeof data === 'string') return data;
    if (typeof data === 'object' && data && 'url' in data) {
      const imageData = data as ImageData;
      return imageData.url || null;
    }
    if (typeof data === 'object' && data && 'src' in data) {
      const imageData = data as ImageData;
      return imageData.src || null;
    }
    return null;
  };

  const imageUrl = getImageUrl();

  if (!imageUrl) {
    return (
      <div className="bg-black/20 rounded-lg p-4">
        <p className="text-white/70">Unable to display frequency response image</p>
      </div>
    );
  }

  return (
    <div className="bg-black/20 rounded-lg p-4">
      <div className="w-full max-w-2xl mx-auto">
        <img
          src={imageUrl}
          alt="Frequency Response Graph"
          className="w-full h-auto"
        />
      </div>
    </div>
  );
}